import { useMemo } from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { ScrollArea } from "@/components/ui/scroll-area";
import { useFilters } from "@/context/FilterContext";

export const UnitPicker = ({ value, onChange, testid = "unit-picker", uid = null }) => {
  const { meta } = useFilters();
  const units = useMemo(() => [...new Set((meta?.units || []).filter((u) => !uid || u.uid === uid).map((u) => u.unit))], [meta, uid]);
  const toggle = (u) => onChange(value.includes(u) ? value.filter((x) => x !== u) : [...value, u]);
  return (
    <ScrollArea data-testid={testid} className="h-44 rounded-md border p-2">
      <div className="grid grid-cols-1 gap-1.5 sm:grid-cols-2">
        {units.map((u) => (
          <label key={u} className="flex cursor-pointer items-center gap-2 rounded px-1.5 py-1 text-xs hover:bg-muted">
            <Checkbox data-testid={`${testid}-${u.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} checked={value.includes(u)} onCheckedChange={() => toggle(u)} />
            {u}
          </label>
        ))}
      </div>
    </ScrollArea>
  );
};

export const PageHeader = ({ eyebrow, title, desc, children }) => (
  <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
    <div>
      <p className="text-xs font-semibold uppercase tracking-widest text-[#F5A623]">{eyebrow}</p>
      <h1 className="font-heading mt-1 text-3xl sm:text-4xl font-extrabold tracking-tight">{title}</h1>
      {desc && <p className="mt-1 max-w-2xl text-sm text-muted-foreground">{desc}</p>}
    </div>
    {children}
  </div>
);
